import BannerDetail from './BannerDetail';

export default BannerDetail;



// WEBPACK FOOTER //
// ./src/scenes/Banners/BannersDetail/index.ts